import Bsa from "../../../jsx/components/Dashboard/BSA/bsa";

const BsaWrapper = () => {
  return <Bsa />;
};

export default constore(BsaWrapper);
